/**
 * Address Helper, only used to retrieve or set values in sequence.
 * @mixin
 */
var AddressHelper = (function(){
    return {
        elementPrefixId:'poiAddress',
        fields: [
            'Description',
            'Street1',
            'Street2',
            'City',
            'State',
            'Zip',
            'Country'
        ],
        /**
         * set@ 
         * Set html elements by combination of elementPrefixId and given fields
         * @param {} values 
         */
        "set":function(values){
            for(var key in this.fields){
                var doc = document.getElementById(this.elementPrefixId+this.fields[key])
                if(doc !== null && values[this.fields[key]] && typeof values[this.fields[key]] !== "undefined" && values[this.fields[key]].trim() !== ""){
                    doc.value = values[this.fields[key]];
                }
            }
        },
        /**
         * get@ 
         * Get html values from the combination  elementPrefixId + fields[]
         */
        "get":function(){
            var values = {};
            for(var key in this.fields){
                // var key = this.fields[key];
                var doc = document.getElementById(this.elementPrefixId+this.fields[key])
                if(doc !== null && this.fields[key] && typeof this.fields[key] !== "undefined" && this.fields[key].trim() !== ""){
                    values[this.fields[key]] = doc.value;
                }
            }
            return values;
        },
        "clean":function(){
            for(var key in this.fields){
                var doc = document.getElementById(this.elementPrefixId+this.fields[key])
            }
        },
        /**
         * getFull@ 
         * Get HTML elements full Address in a string from the combination of elementPrefixId + fields[]
         */
        "getFull":function(){
            var address =[],list=this.get(),
            separator = ', ', avoidSeparatorOn = ['State','Country'],exclude = ['Description'];
            for(var key in list){
                if(list[key].length){
                    var excludeOn = exclude.find(function(f){return f===key;});
                    if(excludeOn !== key) {
                        var avoidSeparator = avoidSeparatorOn.find(function(f){return f===key;});
                        var s = avoidSeparator === key ? ' ': separator;
                        address.push(list[key] + s);
                    }
                }
            }
            return address.join('').toString().trim();
        },
        "getFullFromObject":function(list){
            var address =[], exclude = ['Description'];
            for(var key in list){
                
                var excludeOn = exclude.find(function(f){return f===key;});
                if(list[key] && excludeOn !== key){
                    address.push(list[key]);
                }
            }
            return address.join(', ').toString().trim();
        }
    };
})();

if (typeof exports !== 'undefined') {
    module.exports = AddressHelper;
}